'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactStripeElements = require('react-stripe-elements');

var _reactIntl = require('react-intl');

var _Col = require('web-makeup/dist/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Switch = require('web-makeup/dist/Switch');

var _Switch2 = _interopRequireDefault(_Switch);

var _typography = require('web-makeup/dist/design-system/styles/typography');

var _CreditCardForm = require('./CreditCardForm.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var CreditCardForm = function CreditCardForm(_a) {
    var saveCard = _a.saveCard,
        onSaveCardToogle = _a.onSaveCardToogle;
    var _b = React.useState(),
        cardType = _b[0],
        setCardType = _b[1];
    var _c = React.useState(),
        error = _c[0],
        setError = _c[1];
    var validCardTypes = ['visa', 'mastercard', 'amex'];
    var onCreditFormChange = function onCreditFormChange(change) {
        setCardType(change.brand);
        setError(change.error);
    };
    return React.createElement(React.Fragment, null, React.createElement(_CreditCardForm.FormContainer, { type: "flex", gutter: 10 }, React.createElement(_Col2.default, { span: 24, sm: 16 }, cardType && validCardTypes.includes(cardType) && React.createElement(_CreditCardForm.CardIcon, { useSourceFormat: true, source: { id: "-homepage-icons/-footer/icon-" + cardType, type: 'upload' } }), React.createElement("label", { htmlFor: "credit-card-number" }, React.createElement(_reactIntl.FormattedMessage, { id: "Number" })), React.createElement(_reactStripeElements.CardNumberElement, { style: { base: _CreditCardForm.stripeElementStyleConfig }, onChange: onCreditFormChange }), error && React.createElement(_CreditCardForm.ErrorMessage, null, error.message)), React.createElement(_Col2.default, { span: 6, sm: 4 }, React.createElement("label", { htmlFor: "expiry-date" }, React.createElement(_reactIntl.FormattedMessage, { id: "Expiry" })), React.createElement(_reactStripeElements.CardExpiryElement, { style: { base: _CreditCardForm.stripeElementStyleConfig }, onChange: onCreditFormChange })), React.createElement(_Col2.default, { span: 6, sm: 4 }, React.createElement("label", { htmlFor: "cvc-cvs" }, React.createElement(_reactIntl.FormattedMessage, { id: "CVC" })), React.createElement(_reactStripeElements.CardCvcElement, { style: { base: _CreditCardForm.stripeElementStyleConfig }, onChange: onCreditFormChange }))), React.createElement(_CreditCardForm.AlignedContainer, null, React.createElement(_typography.Text, { fontSize: "h5", fontWeight: "black" }, React.createElement(_reactIntl.FormattedMessage, { id: "Save card" })), React.createElement(_Switch2.default, { onChange: onSaveCardToogle, checked: saveCard })));
};
exports.default = CreditCardForm;
//# sourceMappingURL=CreditCardForm.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/CreditCardForm/CreditCardForm.js
// module id = 1963
// module chunks = 0